export default __webpack_public_path__ + "static/media/adegadosarcos.d36cd4dc.jpeg";